
import { defineComponent } from 'vue';
import PrzItem from './AbstractItem/Component.vue';
import PrzProduct from './Product/Component.vue';
import PrzSocial from './Social/Component.vue';
import PrzWhy from './Why/Component.vue';
import PrzContent from './Content/Component.vue';

import Mub from '@/components/Mub.vue';
import { BlockItem } from '@/models/Blocks/Itens/block-item';
import { BlockItemType } from '@/models/Blocks/Itens/Types/block-item-type';

export default defineComponent({
    components:{
        PrzItem,
        PrzProduct,
        PrzSocial,
        PrzWhy,
        PrzContent,
        Mub,
        
        //Used in specific pages
        PrzPromo: () => import('./Promo/Component.vue'),
        PrzCategory: () => import('./Category/Component.vue'),
        PrzBundle: () => import('./Bundle/Component.vue')
    },
    props:{
        item:{
            type: BlockItem
        }
    },
    computed:{
        isCategory(){
            return this.item && this.item.type == BlockItemType.category;
        },
        isProduct(){
            return this.item && this.item.type == BlockItemType.product;
        },
        isWhy(){
            return this.item && this.item.type == BlockItemType.why;
        },
        isSocial(){
            return this.item && this.item.type == BlockItemType.social;
        },
        isImage(){
            return this.item && this.item.type == BlockItemType.image;
        },
        isEmpty(){
            return this.item && this.item.type == BlockItemType.empty;
        },
        isContent(){
            return this.item && this.item.type == BlockItemType.content;
        },
        isPromo(){
            return this.item && this.item.type == BlockItemType.promo;
        },
        isBundle(){
            return this.item && this.item.type == BlockItemType.bundle;
        }
    }
});
